import * as apiSW from 'api/recipeCategory/GetRecipeCategoryStartingWithV1';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class RecipeCategory {
	id: string = '';
	name: string = '';

	public constructor(input?: apiSW.ResponseRecipeCategory) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public toSelectItem(): ISelectItem {
		return {
			id: this.id,
			name: this.name,
		};
	}

	private mapFromApi(input: apiSW.ResponseRecipeCategory): void {
		this.id = input.id;
		this.name = input.description;
	}
}
